import React from 'react';
import { Media } from "../../../media";
import HeaderContext from './HeaderContext';
import HeaderDesktop from './HeaderDesktop';
import HeaderMobile from './HeaderMobile';

var Header = function Header(_ref) {
  var _ref$user = _ref.user,
      user = _ref$user === void 0 ? null : _ref$user,
      _ref$navigation = _ref.navigation,
      navigation = _ref$navigation === void 0 ? [] : _ref$navigation,
      navigationTopics = _ref.navigationTopics,
      additionalContentSlot = _ref.additionalContentSlot,
      notifications = _ref.notifications,
      profileLinks = _ref.profileLinks,
      siteName = _ref.siteName,
      logoUrl = _ref.logoUrl,
      isSearchMode = _ref.isSearchMode,
      _ref$isServicesDisabl = _ref.isServicesDisabled,
      isServicesDisabled = _ref$isServicesDisabl === void 0 ? false : _ref$isServicesDisabl,
      _ref$isBeta = _ref.isBeta,
      isBeta = _ref$isBeta === void 0 ? false : _ref$isBeta,
      onClickLogin = _ref.onClickLogin,
      onClickLogout = _ref.onClickLogout,
      onClickRegister = _ref.onClickRegister,
      onSubmitSearch = _ref.onSubmitSearch,
      onSearchModeChange = _ref.onSearchModeChange,
      customHandleLangChange = _ref.customHandleLangChange;
  return /*#__PURE__*/React.createElement(HeaderContext.Provider, {
    value: {
      isServicesDisabled: isServicesDisabled,
      logoUrl: logoUrl,
      isBeta: isBeta,
      user: user
    }
  }, /*#__PURE__*/React.createElement(Media, {
    lessThan: "lg"
  }, /*#__PURE__*/React.createElement(HeaderMobile, {
    navigationTopics: navigationTopics,
    additionalContentSlot: additionalContentSlot,
    onSubmitSearch: onSubmitSearch,
    onClickLogin: onClickLogin,
    onClickLogout: onClickLogout,
    onClickRegister: onClickRegister,
    navigation: navigation,
    siteName: siteName,
    customHandleLangChange: customHandleLangChange,
    notifications: notifications
  })), /*#__PURE__*/React.createElement(Media, {
    greaterThanOrEqual: "lg"
  }, /*#__PURE__*/React.createElement(HeaderDesktop, {
    onSubmitSearch: onSubmitSearch,
    onClickLogin: onClickLogin,
    onClickLogout: onClickLogout,
    navigation: navigation,
    additionalContentSlot: additionalContentSlot,
    profileLinks: profileLinks,
    siteName: siteName,
    isSearchMode: isSearchMode,
    onSearchModeChange: onSearchModeChange,
    customHandleLangChange: customHandleLangChange,
    notifications: notifications
  })));
};

export default Header;